/* eslint-disable max-len */
import React from 'react';

const Bell: React.FC<object> = () => {
    return (
        <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.58331 5.99992C1.58331 5.99992 1.65629 4.52063 2.24998 3.33325C2.91665 1.99992 4.25005 1.33325 4.25005 1.33325"
                stroke="currentColor"
                strokeLinecap="round"
            />
            <path
                d="M14.9167 5.99992C14.9167 5.99992 14.8437 4.52063 14.25 3.33325C13.5834 1.99992 12.2499 1.33325 12.2499 1.33325"
                stroke="currentColor"
                strokeLinecap="round"
            />
            <path
                d="M10.25 15.3333L6.25 15.3333"
                stroke="currentColor"
                strokeLinecap="round"/>
            <path
                d="M8.25002 13.3334H2.38943C1.91172 13.3334 1.6873 12.7034 2.03245 12.3732C2.38796 12.033 2.73578 11.6551 2.91669 11.3334C4.24903 8.96422 4.04746 7.27443 4.91669 4.66675C5.58335 2.66675 8.25002 2.66675 8.25002 2.66675C8.25002 2.66675 10.9167 2.66675 11.5834 4.66675C12.4526 7.27443 12.251 8.96422 13.5834 11.3334C13.7041 11.5482 13.8993 11.7879 14.1214 12.0248C14.5571 12.4894 14.2566 13.3334 13.6197 13.3334H8.25002Z"
                stroke="currentColor"
            />
            <path
                d="M6.91669 2.66675L8.21002 1.69675C8.2352 1.67786 8.25002 1.64822 8.25002 1.61675V0.666748"
                stroke="currentColor"
                strokeLinecap="round"
            />
            <path
                d="M9.58331 2.66675L8.28998 1.69675C8.2648 1.67786 8.24998 1.64822 8.24998 1.61675V0.666748"
                stroke="currentColor"
                strokeLinecap="round"
            />
            <path
                d="M9.38135 2.73137C9.68141 2.43131 9.84998 2.02435 9.84998 1.6C9.84998 1.17565 9.68141 0.768687 9.38135 0.46863C9.08129 0.168573 8.67433 0 8.24998 0C7.82563 0 7.41867 0.168573 7.11861 0.46863C6.81855 0.768687 6.64998 1.17565 6.64998 1.6C6.64998 2.02435 6.81855 2.43131 7.11861 2.73137C7.41867 3.03143 7.82563 3.2 8.24998 3.2C8.67433 3.2 9.08129 3.03143 9.38135 2.73137Z"
                fill="currentColor"
            />
        </svg>

    );
};

export default Bell;